import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutation";
import actions from "./action";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

const persistPaths = [
  "userInfo",
  // "userMediaList",
  // "mediaListTag",
  // "currentUserData",
  "masterId",
  "settingData"
];

const state = {
  urlData: {
    source_scheme: "",
    platform: "",
    product_kind: "",
    username: "",
    full_name: "",
    image_src: "",
    follow_count: "",
    like_count: "",
    view_count: "",
    comment_count: "",
    user_coin: "",
    userJson: {},
    taskJson: {},
    offer_id: "",
    app_kind: ""
  },
  masterId: "",
  settingData: {},
  postData: {
    button_id: "", //从表单post的数据
    custom: ""
  },
  userInfo: {}, //用户信心
  userMediaList: [], //用户媒体列表信息
  likeTabData: {
    like_url: "",
    like_count: "",
    view_count: "",
    comment_count: "",
    media_type: 1
  }, //like页面的头像和具体like数目
  service_list: [], //订阅列表
  subs_follow_month: [], //订阅原始的数组
  subs_follow_week: [],
  subs_like_month: [],
  subs_like_week: [],
  vip_list: [], //vip最终的数组
  schemeUrl: "",
  mediaListTag: {
    more_available: "",
    max_id: ""
  },
  navTitleName: "",
  confirmShow: false,
  historyBackShow: false,
  coinShow: false,
  collectShow: true,
  taskJsonSign: false,
  tabbarShow: false, // 底部tabbar显示隐藏
  dataUrl: "", //?后的url地址
  tabSeleced: "", //tabbar 选择的项
  loadingShow: false, //显示loading
  midLoadingShow: false, //显示过度laoding
  midLoadingText: "", //显示过渡loading的文字
  mtStatus: true, //显示tabar开关 通过url控制
  vipStatus: false, //是否为vip用户
  toastShow: false, //失败的Toast
  toastText: "", //失败的toastText
  toastPosition: "", // 失败toast的loading位置
  navbarShow: true, // 顶部的navbar
  currentUserData: {},
  // mediaListTags:{"user_id":"","more_available":false,"max_id":""},
  allPostData: [],
  allPostCate: "All",
  allPostSelectedId: "",
  subs_tab_show: 0,
  //----------------------------------web---------------------------------------
  web_tabbar_show: false, // tabbar
  web_navbar_show: false, // nabBar
  web_navimg_show: true, // nav的头像
  web_account_show: false, //顶部的账户切换
  web_account_history_show: false, //history
  web_account_data: [], //用户的数据
  web_ios_addHome_show: false,
  web_android_addHome_show: false,
  web_safari_ads_show: false,
  web_android_ads_show: false,
  web_login_show: false, //登录
  web_edit_button_show: true, // edit
  web_another_account_show: true, //another count
  web_history_data: [],
  web_login_detail_show: false,
  web_guide_show: false,
  web_payment_show: false,
  pay_result: {},
  payment_had_show: false, //是否显示过购买成功Toast
  web_free_payment_show: false,
  freeListShow: true
};
export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [
    createPersistedState({
      paths: persistPaths
    })
  ]
});



// WEBPACK FOOTER //
// ./src/vuex/store.js